import { Button } from '#/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '#/components/ui/dialog';
import redirectSignin from '#/utils/redirectSignin';
import { DialogProps } from '@radix-ui/react-dialog';
import { Translation } from 'intl-lib';

export function LogoutDialog(props: DialogProps) {
  return (
    <Dialog {...props}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>
            <Translation path="UserNav.SignOut.Title" />
          </DialogTitle>
          <DialogDescription>
            <Translation path="UserNav.SignOut.Description" />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="secondary">
              <Translation path="Application.Dialog.CancelButtonLabel" />
            </Button>
          </DialogClose>
          <Button
            variant="primary"
            onClick={() => {
              redirectSignin();
            }}
          >
            <Translation path="UserNav.SignOut.ButtonLabel" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
